import { nav } from "./nav";
import { hero } from "./hero";
import { dashboard } from "./dashboard";
import { faq } from "./faq";
import { footer } from "./footer";
import { pricing } from "./pricing";
import { howItWorks } from "./howItWorks";
import { favorites } from "./favorites";
import { memberProfile } from "./memberProfile";
import { incomingRequests } from "./incomingRequests";
import { migrated } from "./migrated";
import { countries } from "./countries";

export const common = {
  nav,
  hero,
  dashboard,
  faq,
  footer,
  pricing,
  howItWorks,
  favorites,
  memberProfile,
  incomingRequests,
  migrated,
  countries,
  corporate: {
    hero: {
      title: "Reinventar a viagem",
      subtitle: "Uma visão ética, local e humana do turismo do amanhã.",
    },
    mission: {
      badge: "Nossa Missão",
      title: "Turismo justo",
      description:
        "Acreditamos que viajar deve ser acessível a todos, sem intermediários caros. DONKEY TRAVEL permite aos proprietários viajar livremente graças ao valor da sua própria propriedade.",
    },
    philosophy: {
      badge: "Nossa Filosofia",
      title: "Feito na França e humano",
      description:
        "Enraizados no Vale do Somme, defendemos um modelo artesanal frente aos gigantes da tecnologia. Sem algoritmos obscuros, apenas bom senso e convivialidade.",
      values: {
        fair: {
          title: "Justo",
          desc: "0% de comissão nas trocas. Apenas uma subscrição transparente.",
        },
        local: {
          title: "Enraizamento Local",
          desc: "Orgulhosos das nossas raízes francesas, promovemos um turismo respeitoso.",
        },
        community: {
          title: "Comunidade",
          desc: "Um clube privado de proprietários de confiança que partilham os mesmos valores.",
        },
      },
    },
    team: {
      badge: "A Equipe",
      title: "Apaixonados ao seu serviço",
      subtitle:
        "Por trás da plataforma, humanos que adoram viajar e partilhar.",
      members: {
        ceo: {
          name: "Plük",
          role: "Criador do DONKEY TRAVEL • Desenvolvedor • Superhost Airbnb há 4 anos",
          bio: "Durante anos, acolhi viajantes nas minhas casas, onde eu próprio poderia ter ido se a DONKEY TRAVEL existisse. Foi por isso que criei a DONKEY TRAVEL: para permitir que os anfitriões se acolham uns aos outros e viajem de outra forma.",
        },
        cto: {
          name: "Marie Martin",
          role: "CTO",
          bio: "Arquiteta da plataforma, guardiã da segurança.",
        },
        cmo: {
          name: "Sophie Bernard",
          role: "Responsável de Comunicação",
          bio: "A voz do DONKEY TRAVEL para a nossa comunidade.",
        },
      },
    },
    investors: {
      badge: "Investidores",
      title: "Junte-se à aventura",
      description:
        "O DONKEY TRAVEL está em pleno crescimento. Procuramos parceiros que partilhem a nossa visão de um turismo sustentável e justo.",
      cta: "Contacte-nos para investir",
    },
  },
  trokOrigin: {
    badge: "Entender o conceito",
    title: "O Intercâmbio, o que é exatamente?",
    subtitle:
      "Uma troca direta entre duas pessoas, sem intermediários nem sistema de pontos complicado",
    etymology: {
      title: "A origem da palavra",
      historicalTitle: "Uma prática milenar",
      text1:
        'A palavra "Troc" aparece em francês no século XIV, derivada do verbo "troquer". Tem raízes no espanhol "trucque" e no valão "trouk", evocando a ideia de troca direta.',
      text2:
        'Atestado desde 1364 sob a forma "truke" em documentos anglo-normandos, depois oficializado em 1464 nas cartas patentes de Luís XI: "para venda, troca ou permuta dessas mercadorias".',
      text3:
        "Na DONKEY TRAVEL, mantivemos essa filosofia ancestral: você troca diretamente sua casa com outro proprietário. Sem moeda virtual, sem pontos para acumular. Apenas um acordo entre dois humanos.",
      from: "Etimologia",
      meaning: "Trocar diretamente, de pessoa para pessoa",
      century14: "Século XIV",
      firstAttestation: "Primeira atestação em francês",
      century15: "Século XV",
      officialUse: "Uso oficial por Luís XI",
      today: "Hoje",
      modernPractice: "Prática moderna e colaborativa",
    },
    direct: {
      title: "Apenas troca direta",
      description:
        "Ao contrário dos sistemas de pontos ou créditos, a DONKEY TRAVEL funciona no princípio da troca pura. Você negocia diretamente com outro proprietário: suas noites pelas dele. É a própria essência da troca tal como existe desde o século XIV.",
      result: "Troca direta validada!",
    },
    noTriangulation: {
      title: "Sem triangulação",
      description:
        "Sem sistema complexo onde A dá a B que dá a C. Aqui é simples: você encontra alguém, negociam juntos (datas simultâneas ou não), vocês trocam. Ponto final.",
      noPoints: "Sem pontos para contar",
    },
    meetHost: {
      title: "Conheça outro anfitrião Airbnb",
      description:
        "DONKEY TRAVEL não é apenas descobrir uma casa ou viajar. É, acima de tudo, conhecer outro apaixonado por acolhimento, alguém que partilha seus valores de hospitalidade. A troca sempre foi uma prática social antes de ser econômica.",
      share: "Partilhe suas experiências de anfitrião",
      tips: "Troque suas melhores dicas",
      friendship: "Crie amizades duradouras",
      badge: "Comunidade de anfitriões",
      badgeSub: "Encontros autênticos",
      step2Title: "2. Contrato amigável na DONKEY TRAVEL",
      step2Desc:
        "Eles assinam o contrato de troca diretamente na plataforma e recebem o PDF por email. Tudo é seguro e oficial.",
      contractSigned: "Contrato assinado e seguro",
      step3Title: "3. Maria chega a Paris (2 semanas depois)",
      step3Desc:
        "João acolhe Maria calorosamente. Ele fica impressionado: o apartamento está impecável, Maria respeita tudo. Que diferença de alguns viajantes Airbnb! Eles conversam sobre suas experiências de anfitriões tomando um café.",
      step4Title: "4. João descobre Reims (6 meses depois)",
      step4Desc:
        "João chega à casa de campo de Maria em Reims. O cenário é magnífico! Maria convida-o para jantar, comem juntos e refazem o mundo falando de viagens, Airbnb e suas melhores histórias de anfitriões.",
      step5Title: "5. Uma amizade duradoura",
      step5Desc:
        "Maria e João mantêm contato. Decidem trocar regularmente suas casas. Mais do que uma simples troca, é uma verdadeira amizade que nasceu graças à TRAVELTROK.",
      spiritTitle: "Eis o espírito DONKEY TRAVEL!",
      spiritDesc:
        "Trocas autênticas entre proprietários apaixonados, com respeito e convivialidade. Sem pontos, sem triangulação, apenas troca verdadeira à moda antiga.",
    },
    negotiation: {
      badge: "Negociação lúdica",
      title: "Negocie como um jogo!",
      description:
        "10 noites contra 5? Por que não! Faça uma oferta, receba uma contraproposta, chegue a um acordo. Tudo com bom espírito. Como nos tempos das primeiras trocas, a negociação faz parte do prazer.",
      marieProperty: "Casa em Reims",
      jeanProperty: "Apartamento em Paris",
      marieLocation: "Na sua casa em Reims",
      jeanLocation: "No seu apartamento em Paris",
      marieAccepts: "Maria aceita a oferta",
      offers: "Oferta",
      proposes: "Propõe",
      nights: "noites",
      status: {
        initial: "Maria faz uma oferta...",
        counter: "João faz uma contraproposta!",
        negotiate: "Maria negocia...",
        deal: "Negócio fechado! 🎉",
      },
      chat: {
        msg1: "Proponho {{marieNights}} noites na minha casa em Reims contra {{jeanNights}} noites em Paris!",
        msg2: "João acha a casa da Maria muito boa...",
        msg3: "Tua casa é magnífica! Sou simpático, proponho {{jeanNights}} noites em Paris 😊",
        msg4: "Negócio fechado! 🤝",
        msg5: "Maria verifica as disponibilidades de João...",
      },
      nextStep: "Próxima etapa",
      restart: "Recomeçar",
      points: {
        flexible: "Negociação flexível",
        friendly: "Ambiente amigável",
        fair: "Acordo justo",
      },
    },
    flexibility: {
      title: "Flexibilidade total",
      description:
        "Ao contrário das trocas tradicionais, você não precisa encontrar alguém que queira sua casa exatamente quando você quer a dele. Acumule Noites e use-os quando quiser!",
    },
    example: {
      person1: "Maria",
      location1: "Paris, França",
      person2: "João",
      location2: "Lyon, França",
      result: "Troca bem sucedida!",
    },
  },
  exchange: {
    title: "Como funciona?",
    subtitle:
      "Um sistema simples e seguro para trocar suas casas com confiança",
    features: {
      secure: {
        title: "Trocas seguras",
        description:
          "Todos os membros são verificados e as avaliações garantem a transparência de cada troca.",
      },
      sync: {
        title: "Sincronização de calendário",
        description:
          "Sincronize automaticamente suas disponibilidades com seu calendário Airbnb existente.",
      },
      global: {
        title: "Rede europeia",
        description:
          "Aceda aos membros anfitriões nos países europeus disponíveis na TRAVELTROK.",
      },
      chat: {
        title: "Mensagens integradas",
        description:
          "Comunique diretamente com outros proprietários para organizar suas trocas.",
      },
      rating: {
        title: "Sistema de avaliação",
        description:
          "Consulte as avaliações e notas para escolher seus parceiros de troca com confiança.",
      },
      savings: {
        title: "Economias garantidas",
        description:
          "Viaje gratuitamente usando seus Noites em vez de pagar alojamentos caros.",
      },
    },
    steps: {
      title: "Em 3 etapas simples",
      step1: {
        title: "Crie seu perfil",
        description:
          "Inscreva-se e adicione as informações da sua casa Airbnb em alguns minutos.",
      },
      step2: {
        title: "Encontre seu destino",
        description:
          "Navegue pelos alojamentos disponíveis e encontre o destino dos seus sonhos.",
      },
      step3: {
        title: "Troque e viaje",
        description:
          "Proponha uma troca, confirme as datas e aproveite sua estadia gratuitamente!",
      },
    },
  },
  worldMap: {
    title: "Top 20 dos países mais ativos",
    subtitle:
      "Descubra os países onde as trocas de casas são mais populares hoje",
    description:
      "Nossa comunidade cresce a cada dia com novos proprietários em todo o mundo. Descubra para onde você poderia viajar gratuitamente.",
    badge: "Classificação em tempo real",
    properties: "alojamentos",
    cta: "Ver todos os destinos",
    exchangesToday: "Trocas hoje",
    activeCountries: "Países ativos",
    vsYesterday: "vs. ontem",
    fullRanking: "Classificação completa",
    countries: {
      Guadeloupe: "Guadalupe",
      Martinique: "Martinica",
      Guyane: "Guiana Francesa",
      "La Réunion": "Reunião",
      Mayotte: "Maiote",
      "Polynésie française": "Polinésia Francesa",
      "Nouvelle-Calédonie": "Nova Caledônia",
      "Îles Canaries": "Ilhas Canárias",
      "Ceuta & Melilla": "Ceuta e Melilha",
      Madère: "Madeira",
      Açores: "Açores",
      Aruba: "Aruba",
      Curaçao: "Curaçao",
      "Saint-Martin": "São Martinho",
      Bermudes: "Bermudas",
      "Îles Caïmans": "Ilhas Cayman",
      Gibraltar: "Gibraltar",
      france: "França",
      spain: "Espanha",
      italy: "Itália",
      usa: "Estados Unidos",
      uk: "Reino Unido",
      germany: "Alemanha",
      portugal: "Portugal",
      netherlands: "Países Baixos",
      canada: "Canadá",
      australia: "Austrália",
      belgium: "Bélgica",
      switzerland: "Suíça",
      greece: "Grécia",
      mexico: "México",
      brazil: "Brasil",
      austria: "Áustria",
      croatia: "Croácia",
      thailand: "Tailândia",
      morocco: "Marrocos",
    },
  },
  calendar: {
    title: "Sincronização automática com Airbnb",
    subtitle: "Conecte seu calendário Airbnb em um clique",
    description:
      "Suas disponibilidades são sincronizadas automaticamente. Não há mais necessidade de gerenciar dois calendários separadamente.",
    features: {
      sync: {
        title: "Sincronização bidirecional",
        description:
          "Seus calendários Airbnb e DONKEY TRAVEL mantêm-se sempre atualizados automaticamente",
      },
      realtime: {
        title: "Atualizações em tempo real",
        description:
          "Cada modificação é instantaneamente sincronizada em ambas as plataformas",
      },
      smart: {
        title: "Gestão inteligente",
        description:
          "Evite reservas duplas graças ao nosso sistema de sincronização avançado",
      },
    },
    cta: "Conectar meu calendário",
  },
  airbnb: {
    title: "Já é proprietário Airbnb?",
    subtitle: "Junte-se à DONKEY TRAVEL e comece a viajar gratuitamente",
    description:
      "Importe automaticamente as informações da sua casa Airbnb e comece a trocar hoje mesmo.",
    features: {
      verification: {
        title: "Verificação automática do seu perfil",
      },
      import: {
        title: "Importação das suas fotos e descrições",
      },
      trust: {
        title: "Junte-se a uma comunidade de confiança",
      },
    },
    cta: "Conectar meu Airbnb",
  },
  membersMap: {
    title: "Mapa de Membros",
    searchPlaceholder: "Pesquisar um destino, cidade...",
    filters: "Filtros",
    radius: "Raio",
    radiusAuto: "Automático",
    reset: "Redefinir",
    filterPets: "Animais aceites",
    filterVerified: "Anfitriões verificados",
    filterRating: "4.8+",
    filterAllTypes: "Todos os tipos",
    oneTraveler: "1 viajante",
    multipleTravelers: "{{count}} viajantes",
    dates: "Datas",
    addDates: "Adicionar datas",
    startDate: "Partida",
    endDate: "Regresso",
    listingsTitle: "Alojamentos",
    listingsSubtitle: "Selecione para ver no mapa.",
    pagination: "{{current}} / {{total}}",
    clearFilters: "Limpar filtros",
    guestsShort: "p.",
    bedroomsShort: "q.",
    surfaceAreaUnit: "m²",
    perNight: "/ noite",
    online: "Conectado",
    offline: "Desconectado",
    verified: "Verificado",
    favorite: "Favorito",
    favorites: "Favoritos",
    members: "Membros",
    exchanges: "trocas",
    rooms: "divisões",
    mapTitle: "Mapa interativo dos membros DONKEY TRAVEL",
    countries: "Países",
    results: "resultados",
    viewProfile: "Ver perfil",
    proposeExchange: "Propor uma troca",
    showFavoritesOnly: "Mostrar apenas favoritos",
    advancedSearch: "Pesquisa avançada",
    refineSearch: "Refinar sua pesquisa",
    activeFilter: "filtro ativo",
    activeFilters: "filtros ativos",
    availabilityDates: "Datas de disponibilidade",
    quickPeriods: "Períodos rápidos",
    thisMonth: "Este mês",
    nextMonth: "Próximo mês",
    next3Months: "Próximos 3 meses",
    summer: "Verão",
    autumn: "Outono",
    winter: "Inverno",
    arrival: "Chegada",
    departure: "Partida",
    flexibleDates: "Datas flexíveis",
    clear: "Limpar",
    propertyTypeTitle: "Tipo de alojamento",
    apartment: "Apartamento",
    house: "Casa",
    villa: "Villa",
    loft: "Loft",
    capacityAndRooms: "Capacidade e divisões",
    numberOfTravelers: "Número de viajantes",
    all: "Todos",
    numberOfRooms: "Número de divisões",
    minimumSurface: "Superfície mínima",
    equipments: "Equipamentos",
    wifi: "Wi‑Fi",
    pool: "Piscina",
    parking: "Estacionamento",
    airConditioning: "Ar condicionado",
    garden: "Jardim",
    terrace: "Terraço",
    fireplace: "Lareira",
    barbecue: "Churrasqueira",
    bike: "Bicicleta",
    sauna: "Sauna",
    gym: "Ginásio",
    washingMachine: "Máquina de lavar",
    statusAvailability: "Status e disponibilidade",
    onlineAvailability: "Disponibilidade em tempo real",
    onlineOnly: "Apenas conectados",
    verifiedMembersOnly: "Apenas membros verificados",
    ratingExperience: "Nota e experiência",
    minimumRating: "Nota mínima",
    minimumExchanges: "Trocas mínimas",
    matchingMembers: "membros correspondentes",
    matchingMember: "membro correspondente",
    seeResults: "Ver os",
    result: "resultado",
    resetAllFilters: "Redefinir todos os filtros",
    rating: "Nota",
    travelers: "Viajantes",
    contact: "Contatar",
    searchMemberCity: "Pesquisar membro, cidade, país...",
    noFavorite: "Nenhum favorito",
    addFavoritesHint: "Adicione membros aos favoritos clicando no coração",
    noMemberFound: "Nenhum membro encontrado",
    tryModifyFilters: "Tente modificar seus filtros",
    viewAllMembers: "Ver todos os membros",
    modifyFilters: "Modificar filtros",
    favoritesOnly: "Apenas favoritos",
    addToFavorites: "Adicionar aos favoritos",
    removeFromFavorites: "Remover dos favoritos",
    loading: "Carregando...",
    sortBy: "Ordenar por",
    relevance: "Relevância",
    newest: "Mais recentes",
    noResults: "Nenhum resultado encontrado",
    tryDifferentFilters: "Tente ajustar seus filtros de pesquisa",
    membersList: "Lista de membros",
    membersFound: "membros encontrados",
    visibleMembers: "Membros visíveis",
    legend: "Legenda",
    availableProperty: "Alojamento disponível",
    selected: "Selecionado",
    visibleByAll: "Visível por todos",
    allMembersSeeYou: "Todos os membros veem você",
    targetedMode: "Modo direcionado",
    countriesSelected: "países selecionados",
    countrySelected: "país selecionado",
    myVisibility: "Minha visibilidade",
    whoCanSee: "Quem pode ver minha casa no mapa?",
    visibleByAllTitle: "Visível por todos",
    visibleByAllDesc:
      "Todos os membros da comunidade podem ver sua casa e propor uma troca.",
    visibleByAllHint: "Máxima visibilidade e oportunidades",
    active: "ATIVO",
    targetedModeTitle: "Modo direcionado",
    targetedModeDesc:
      "Apenas membros dos países que você procura podem ver sua casa. Discrição máxima.",
    targetedModeHint: "Você só vê e é visto pelos seus destinos",
    myDesiredDestinations: "Meus destinos desejados",
    clearAll: "Limpar tudo",
    searchCountry: "Pesquisar um país...",
    member: "membro",
    membersCount: "membros",
    noCountryFound: "Nenhum país encontrado",
    targetedInfoTitle: "Sua casa aparecerá apenas para membros em",
    targetedInfoDesc: "Os outros não verão você no mapa.",
    targetedExample:
      "Exemplo: se você só quer ir para a Holanda, apenas membros holandeses verão seu perfil.",
    selectAtLeastOneCountry:
      "Selecione pelo menos um país para ativar o modo direcionado.",
    propertyTypes: {
      appartement: "Apartamento",
      maison: "Casa",
      villa: "Villa",
      loft: "Loft",
      luxe: "Luxo",
      insolite: "Insolito",
    },
    pricePerNight: "PREÇO POR NOITE (€)",
    min: "Mín",
    max: "Máx",
    sortResults: "ORDENAÇÃO DOS RESULTADOS",
    sort: {
      recommended: "✨ Recomendados",
      priceAsc: "💶 Preço crescente",
      priceDesc: "💎 Preço decrescente",
    },
    amenitiesTitle: "EQUIPAMENTOS",
    amenitiesTabs: {
      all: "TODOS",
      essentials: "ESSENCIAIS",
      features: "CONFORTO",
      location: "LOCALIZAÇÃO",
      safety: "SEGURANÇA",
    },
  },
  amenities: {
    wifi: "Wi-Fi",
    tv: "Televisão",
    kitchen: "Cozinha",
    washing_machine: "Máquina de lavar",
    ac: "Ar condicionado",
    heating: "Aquecimento",
    workspace: "Espaço de trabalho",
    iron: "Ferro de passar",
    hair_dryer: "Secador de cabelo",
    pool: "Piscina",
    hottub: "Jacuzzi",
    patio: "Terraço",
    bbq: "Churrasqueira",
    parking: "Estacionamento gratuito",
    gym: "Ginásio",
    fireplace: "Lareira",
    breakfast: "Café da manhã",
    beachfront: "Beira-mar",
    ski_in_out: "Acesso às pistas",
    lake_access: "Acesso ao lago",
    smoke_detector: "Detector de fumaça",
    first_aid: "Kit de primeiros socorros",
    fire_extinguisher: "Extintor",
  },
  destinations: {
    title: "Destinos",
    searchPlaceholder: "Pesquisar um destino...",
    destinationsFound: "destinos encontrados",
    noResults: "Nenhum resultado",
    tryDifferentSearch: "Tente outra pesquisa",
    sortMembers: "Mais membros",
    sortProperties: "Mais alojamentos",
    sortName: "Nome (A-Z)",
    all: "Todos",
    members: "membros",
    properties: "alojamentos",
    explore: "Explorar este destino",
    stats: {
      destinations: "Destinos",
      members: "Membros",
      properties: "Alojamentos",
      countries: "Países",
    },
    countriesIn: "Países em",
    selectCountry: "— selecione um país para filtrar",
    continents: {
      Europe: "Europa",
      "Amérique du Nord": "América do Norte",
      "Amérique du Sud": "América do Sul",
      Asie: "Ásia",
      Afrique: "África",
      Océanie: "Oceania",
    },
    countries: {
      Turquie: "Turquia",
      France: "França",
      "Pays-Bas": "Países Baixos",
      "Royaume-Uni": "Reino Unido",
      Espagne: "Espanha",
      Italie: "Itália",
      Tchéquie: "Chéquia",
      Grèce: "Grécia",
      Portugal: "Portugal",
      Autriche: "Áustria",
      Écosse: "Escócia",
      Hongrie: "Hungria",
      Croatie: "Croácia",
      Danemark: "Dinamarca",
      Suède: "Suécia",
      Suisse: "Suíça",
      Belgique: "Bélgica",
      Norvège: "Noruega",
      Irlande: "Irlanda",
      Pologne: "Polônia",
      Finlande: "Finlândia",
      Islande: "Islândia",
      Roumanie: "Romênia",
      Monténégro: "Montenegro",
      "États-Unis": "Estados Unidos",
      Canada: "Canadá",
      Mexique: "México",
      "Costa Rica": "Costa Rica",
      Cuba: "Cuba",
      "Rép. Dominicaine": "Rep. Dominicana",
      Guatemala: "Guatemala",
      Brésil: "Brasil",
      Argentine: "Argentina",
      Pérou: "Peru",
      Colombie: "Colômbia",
      Chili: "Chile",
      Équateur: "Equador",
      Uruguay: "Uruguai",
      Bolivie: "Bolívia",
      Chine: "China",
      Thaïlande: "Tailândia",
      Indonésie: "Indonésia",
      Vietnam: "Vietnã",
      "Corée du Sud": "Coreia do Sul",
      Inde: "Índia",
      Cambodge: "Camboja",
      Jordanie: "Jordânia",
      Maldives: "Maldivas",
      "Sri Lanka": "Sri Lanka",
      Népal: "Nepal",
      Philippines: "Filipinas",
      Ouzbékistan: "Uzbequistão",
      Égypte: "Egito",
      Maroc: "Marrocos",
      "Afrique du Sud": "África do Sul",
      Tanzanie: "Tanzânia",
      Kenya: "Quênia",
      Sénégal: "Senegal",
      Madagascar: "Madagascar",
      Tunisie: "Tunísia",
      Zimbabwe: "Zimbábue",
      Namibie: "Namíbia",
      "Île Maurice": "Maurícia",
      Rwanda: "Ruanda",
      Australie: "Austrália",
      "Nouvelle-Zélande": "Nova Zelândia",
      "Polynésie française": "Polinésia Francesa",
      Fidji: "Fiji",
      "Nouvelle-Calédonie": "Nova Caledônia",
      Samoa: "Samoa",
    },
    cities: {
      Paris: "Paris",
      "Mont Saint-Michel": "Monte Saint-Michel",
      Marseille: "Marselha",
      Amsterdam: "Amsterdã",
      Londres: "Londres",
      Barcelone: "Barcelona",
      Madrid: "Madri",
      Venise: "Veneza",
      Rome: "Roma",
      "Côte Amalfitaine": "Costa Amalfitana",
      Prague: "Praga",
      Santorin: "Santorini",
      Athènes: "Atenas",
      Lisbonne: "Lisboa",
      Porto: "Porto",
      Vienne: "Viena",
      Édimbourg: "Edimburgo",
      Budapest: "Budapeste",
      Dubrovnik: "Dubrovnik",
      Copenhague: "Copenhague",
      Stockholm: "Estocolmo",
      Zermatt: "Zermatt",
      Bruges: "Bruges",
      Bergen: "Bergen",
      Dublin: "Dublin",
      Cracovie: "Cracóvia",
      Helsinki: "Helsinque",
      Reykjavik: "Reykjavique",
      Bucarest: "Bucareste",
      Kotor: "Kotor",
      "New York": "Nova York",
      "San Francisco": "São Francisco",
      "Los Angeles": "Los Angeles",
      Miami: "Miami",
      Hawaï: "Havaí",
      Vancouver: "Vancouver",
      Montréal: "Montreal",
      Toronto: "Toronto",
      Banff: "Banff",
      Québec: "Quebec",
      Cancún: "Cancún",
      "Mexico City": "Cidade do México",
      "San José": "San José",
      "La Havane": "Havana",
      "Punta Cana": "Punta Cana",
      Antigua: "Antigua",
      "Buenos Aires": "Buenos Aires",
      "Rio de Janeiro": "Rio de Janeiro",
      "São Paulo": "São Paulo",
      "Machu Picchu": "Machu Picchu",
      Lima: "Lima",
      Carthagène: "Cartagena",
      Bogotá: "Bogotá",
      Santiago: "Santiago",
      Quito: "Quito",
      Montevideo: "Montevidéu",
      "La Paz": "La Paz",
      Tokyo: "Tóquio",
      Kyoto: "Quioto",
      Pékin: "Pequim",
      Shanghai: "Xangai",
      "Hong Kong": "Hong Kong",
      Bangkok: "Bangkok",
      "Chiang Mai": "Chiang Mai",
      Bali: "Bali",
      "Hô Chi Minh-Ville": "Cidade de Ho Chi Minh",
      Séoul: "Seul",
      "Angkor Wat": "Angkor Wat",
      Colombo: "Colombo",
      Katmandou: "Catmandu",
      Manille: "Manila",
      Samarcande: "Samarcanda",
      Petra: "Petra",
      "Le Caire": "Cairo",
      Marrakech: "Marraquexe",
      Chefchaouen: "Chefchaouen",
      "Le Cap": "Cidade do Cabo",
      Johannesburg: "Joanesburgo",
      Zanzibar: "Zanzibar",
      "Safari Masai Mara": "Safári Masai Mara",
      Nairobi: "Nairobi",
      Dakar: "Dacar",
      Antananarivo: "Antananarivo",
      Tunis: "Túnis",
      "Chutes Victoria": "Cataratas Vitória",
      Windhoek: "Windhoek",
      "Île Maurice": "Maurícia",
      Kigali: "Kigali",
      Sydney: "Sydney",
      Melbourne: "Melbourne",
      "Grande Barrière de Corail": "Grande Barreira de Corais",
      Auckland: "Auckland",
      Queenstown: "Queenstown",
      "Bora Bora": "Bora Bora",
      Fidji: "Fiji",
      Nouméa: "Nouméa",
      Apia: "Apia",
      "Baie d'Halong": "Baía de Ha Long",
      Maldives: "Maldivas",
    },
  },
  story: {
    badge: "Uma história verdadeira",
    title: "Chloé e Hugo: a troca perfeita",
    subtitle:
      "Quando uma parisiense cansada da cidade encontra um camponês que sonha com Paris...",
    chloé: {
      aptAlt: "Apartamento de Chloé em Paris",
      quotaExceeded: "Cota Airbnb excedida!",
      role: "Anfitriã Airbnb em Paris",
      speech1:
        'Eu <strong class="text-red-600">excedi minha cota de 120 noites</strong>... Impossível alugar. E, francamente, estou farta do barulho parisiense. 😩',
      nightsTag: "120/120 noites",
      tiredTag: "Cansada de Paris",
      dreamsOf: "Chloé sonha com...",
      dreamTitle: "A calma do campo",
      dreamDesc: "Verde, silêncio, uma sauna... o paraíso!",
      searching: "Procura uma casa de campo",
      findsLuc: "Encontra Hugo!",
      speech2:
        "Finalmente a calma! A sauna depois de um passeio na floresta, é a <strong>felicidade absoluta</strong>. 🌿✨",
      review:
        "A casa do Hugo é um pequeno paraíso! A sauna depois de um passeio na floresta, é a felicidade. Tornámo-nos amigos! Recomendo a 200%.",
    },
    hugo: {
      giteAlt: "Casa de campo de Hugo",
      available: "Disponível o ano todo",
      location: "Campo, França",
      role: "Anfitrião Airbnb no campo",
      speech1:
        'Minha casa tem um <strong class="text-sage-600">jardim, uma sauna e uma cadeira de massagem</strong>... mas não aguento mais o campo. Sonho com Paris! 🗼',
      dreamsOf: "Hugo sonha com...",
      dreamTitle: "As luzes de Paris",
      dreamDesc: "Os museus, os cafés, a Torre Eiffel... finalmente!",
      searching: "Procura um apartamento em Paris",
      findsMaya: "Encontra Chloé!",
      speech2:
        "Paris, finalmente! O Louvre, os bistrôs, os telhados... é <strong>mágico</strong>! 🗼🥐",
      review:
        "O apartamento da Chloé é incrível, vista para os telhados de Paris! E tudo isso sem tocar na cota dela. A troca é genial!",
    },
    tags: {
      garden: "Jardim",
      sauna: "Sauna",
      massage: "Massagem",
      countryside: "Campo",
      bigGarden: "Grande jardim",
      restaurants: "Restaurantes",
      museums: "Museus",
    },
    match: {
      spark: "O clique!",
      title: "Eles descobrem a DONKEY TRAVEL",
      perfect: "Match perfeito!",
    },
    quota: {
      title: "Fora da cota Airbnb = 100% gratuito!",
      description:
        "A estadia do Hugo não afeta a cota da Chloé. É uma troca, não um aluguel. Todos ganham!",
      totalCost: "Custo total",
      quotaNight: "Noite cota",
    },
    happyEnd: {
      title: "Todos estão felizes! 🎊",
      subtitle:
        "Chloé e Hugo tornaram-se amigos. Eles compartilham suas dicas de anfitriões e já planejam uma próxima troca!",
      exchangeSuccess: "Troca bem sucedida",
      newFriendship: "Nova amizade",
      outsideQuota: "Fora da cota",
      free: "100% gratuito",
    },
  },
  messaging: {
    messages: "Mensagens",
    searchPlaceholder: "Pesquisar uma conversa...",
    all: "Todas",
    unread: "Não lidas",
    archived: "Arquivadas",
    online: "Conectado",
    offline: "Desconectado",
    messagePlaceholder: "Escrever uma mensagem...",
    writeMessage: "Escrever uma mensagem",
    sending: "Enviando...",
    characters: "caracteres",
    noConversation: "Nenhuma conversa",
    notificationMessage: "Nova mensagem",
    quickActions: "Ações rápidas",
    proposeExchange: "Propor uma troca",
    proposeExchangeTitle: "Proposta de troca",
    checkAvailability: "Verificar disponibilidades",
    report: "Denunciar",
    hisProperty: "Seu alojamento",
    rooms: "quartos",
    guests: "viajantes",
    verifiedOwner: "Proprietário verificado",
    viewAirbnbListing: "Ver anúncio Airbnb",
    details: "Detalhes",
    desiredDates: "Datas desejadas",
    arrival: "Chegada",
    departure: "Partida",
    period: "Período",
    duration: "Duração",
    nights: "noites",
    numberOfTravelers: "Número de viajantes",
    traveler: "viajante",
    travelers: "viajantes",
    person: "pessoa",
    persons: "pessoas",
    dateFlexibility: "Flexibilidade de datas",
    exactDates: "Datas exatas",
    flex1to2: "± 1-2 dias",
    flex3to5: "± 3-5 dias",
    flexWeek: "± 1 semana",
    personalMessage: "Mensagem pessoal",
    summary: "Resumo",
    termsAccept: "Aceito as condições de troca da DONKEY TRAVEL",
    sendProposal: "Enviar proposta",
    proposalSent: "Proposta enviada!",
    proposalSentMessage: "Sua proposta foi enviada com sucesso",
    close: "Fechar",
    today: "Hoje",
    selectConversation: "Selecione uma conversa",
    selectConversationHint: "Escolha um proprietário para começar a conversar",
  },
  destination_introuvable: `Destino não encontrado`,
  cette_destination_n_apos_existe_pas_ou_a__t__d_pla: `Este destino não existe ou foi movido.`,
  retour_aux_destinations: `Voltar aos destinos`,
  pr_t___d_couvrir_: `Pronto para descobrir`,
  r_server_ce_s_jour: `Reserve esta estadia`,
  explorer_d_apos_autres_destinations: `Explorar outros destinos`,
  acc_s_r_serv_: `Acesso reservado`,
  europe_unique: `Europa Única`,
  "50eur_an_pour__changer_dans_toute_l_europe_": `50EUR/ano para intercâmbio em toda a Europa.`,
  lancement_2026: `Lançamento 2026`,
  club_d__change_h_tes_airbnb: `Clube de troca de anfitriões do Airbnb`,
  optimisez_vos_p_riodes_creuses_gr_ce_aux__changes: `Otimize seus períodos fora de pico graças às trocas`,
  rejoindre_le_club: `Junte-se ao clube`,
  trouver_un_h_te: `Encontre um anfitrião`,
  r_serv__aux_h_tes_traveltrok: `Reservado para hóspedes do DONKEY TRAVEL`,
  voyagez_gratuitement_gr_ce___votre_logement: `Viaje gratuitamente com o seu alojamento`,
  accueillez_des_membres_et_faites_vous_accueillir_e: `Dê as boas-vindas aos membros e seja bem-vindo de volta. Uma troca simples, direta e sem dinheiro entre proprietários.`,
  devenir_h_te: `Torne-se um anfitrião`,
  comment__a_marche__: `Como funciona?`,
  amis_partageant_un_repas_en_corse: `Amigos partilhando uma refeição na Córsega`,
  _nous_avons__chang__notre_maison___lyon_contre_une: `"Trocamos a nossa casa em Lyon por uma villa na Córsega. Custo: 0€."`,
  sophie___marc__membres_depuis_2023: `Sophie & Marc, membros desde 2023`,
  pas_de_monnaie__pas_de_points__juste_un_accord_ent: `Sem moedas, sem pontos. Apenas um acordo entre dois proprietários. Eu vou na sua casa, você vem na minha casa.`,
  "1__accord_mutuel": `1. Acordo mútuo`,
  vous_trouvez_un_membre_qui_vous_pla_t_et_vous_vous: `Você encontra um membro de quem gosta e concorda em trocar de acomodação.`,
  "2__flexibilit__totale": `2. Flexibilidade total`,
  "3__z_ro_comptabilit_": `3. Contabilidade zero`,
  pas_de_points___compter__juste_le_plaisir_de_parta: `Não há pontos para contar. Apenas o prazer de compartilhar e conhecer.`,
  pourquoi_les_h_tes_adorent_ce_syst_me__: `Por que os hosts adoram esse sistema?`,
  plus_qu__une__conomie__c__est_une_nouvelle_fa_on_d: `Mais do que uma economia, é uma nova forma de viajar.`,
  "0__de_frais": `0€ de taxas`,
  les__changes_sont_totalement_gratuits__pas_de_frai: `As trocas são totalmente gratuitas. Sem taxas de serviço, sem taxas de limpeza (a menos que especificamente acordado).`,
  confiance_totale: `Confiança total`,
  seuls_les_h_tes_v_rifi_s_peuvent__changer__vous_ac: `Somente hosts verificados podem negociar. Você está recebendo alguém que conhece o valor da moradia.`,
  simplicit_: `Simplicidade`,
  oubliez_la_valeur_des_points__une_nuit_est_une_nui: `Esqueça o valor dos pontos. Uma noite é uma noite. A troca é baseada na confiança entre hosts.`,
  rejoignez_la_communaut__des_h_tes: `Junte-se à comunidade de anfitriões`,
  rejoignez_la_communaut__et_commencez____changer_: `Junte-se à comunidade e comece a conversar.`,
  commencer_maintenant: `Comece agora`,
  pr_nom_invalide: `Nome inválido`,
  nom_invalide: `Nome inválido`,
  email_invalide: `E-mail inválido`,
  s_lectionne_un_pays: `Selecione um país`,
  s_lectionne_un_mode_tarifaire: `Selecione um método de precificação`,
  s_lectionne_ton_usage: `Selecione seu uso`,
  tu_dois_accepter_les_conditions: `Você deve aceitar as condições`,
  france: `França`,
  belgique: `Bélgica`,
  suisse: `Suíça`,
  canada: `Canadá`,
  allemagne: `Alemanha`,
  espagne: `Espanha`,
  italie: `Itália`,
  portugal: `Portugal`,
  royaume_uni: `Reino Unido`,
  _tats_unis: `Estados Unidos`,
  autre: `Outros`,
  merci_de_corriger_les_champs_en_erreur_: `Corrija os campos incorretos.`,
  une_erreur_est_survenue__r_essaie_dans_quelques_in: `Ocorreu um erro. Tente novamente em alguns instantes.`,
  compte_cr___avec_succ_s: `Conta criada com sucesso`,
  tu_recevras_un_email_pour_finaliser_ton_profil_voy: `Você receberá um e-mail para finalizar seu perfil de viajante/anfitrião.`,
  cr_er_un_autre_compte: `Crie outra conta`,
  activation_traveltrok: `Ativação DONKEY TRAVEL`,
  choisis_ton_mode__voyageur__h_te__ou_usage_mixte_: `Escolha o seu modo: viajante, anfitrião ou uso misto.`,
  pr_nom: `Nome`,
  jeanne: `Jane`,
  nom: `Nome`,
  durand: `Durand`,
  email: `E-mail`,
  jeanne_email_com: `jeanne@email.com`,
  t_l_phone__optionnel_: `Telefone (opcional)`,
  pays: `País`,
  choisir_un_pays: `Escolha um país`,
  mode_tarifaire: `Método de precificação`,
  voyageur: `Viajante`,
  nuit: `noite`,
  h_te: `Anfitrião`,
  pro_multi_logements: `Multi-habitação profissional`,
  mois: `mês`,
  usage_principal: `Uso principal`,
  je_voyage_principalement: `Eu viajo principalmente`,
  je_loue_principalement: `Alugo principalmente`,
  je_fais_les_deux: `Eu faço as duas coisas`,
  nombre_de_logements: `Número de alojamentos`,
  logement: `alojamento`,
  logements: `alojamento`,
  a: `uma`,
  j_accepte_les_conditions_d_utilisation_et_la_polit: `Aceito os termos de uso e política de privacidade.`,
  cr_ation_en_cours___: `Criação em andamento...`,
  cr_er_mon_compte_traveltrok: `Criar minha conta DONKEY TRAVEL`,
  r_servation_de_logements: `Reserva de alojamento`,
  support_h_te_prioritaire: `Suporte prioritário ao anfitrião`,
  carte___filtres_avanc_s: `Mapa + filtros avançados`,
  flux_de_r_servation__tape_par__tape: `Fluxo de reserva passo a passo`,
  couverture_dommages_assistance: `Cobertura de danos/assistência`,
  multi_logements___reporting: `Multi-habitação + relatórios`,
  accueil: `Início`,
  tarifs: `Preços`,
  "0__commission_pour_les_h_tes": `0% de Comissão para Anfitriões`,
  r_volution_traveltrok: `Revolução DONKEY TRAVEL`,
  gardez_100__de_ce_que_vous_gagnez: `Fique com 100% do que você ganha`,
  simple: `Simples`,
  tu_connais_ton_co_t_avant_de_r_server__aucun_effet: `Você sabe o seu custo antes de reservar. Sem surpresas ao pagar.`,
  honn_te: `Honesto`,
  le_m_me_principe_pour_tous__voyageur_et_h_te_sont_: `O mesmo princípio para todos: viajante e anfitrião são tratados com a mesma regra.`,
  utile: `Útil`,
  je_suis_voyageur: `Sou um viajante`,
  je_suis_h_te: `Sou anfitrião`,
  j_ai_plusieurs_logements: `Tenho diversas acomodações`,
  simulateur_comparatif_host: `Simulador de host comparativo`,
  compare_booking__airbnb_et_traveltrok_avec_tes_pro: `Compare Booking, Airbnb e DONKEY TRAVEL com seus próprios números.`,
  nombre_de_nuits: `Número de noites`,
  property_price___night__eur_: `Preço do imóvel / noite (EUR)`,
  autres_frais__m_nage__accueil__linge_____eur: `Outros custos (limpeza, recepção, roupa de cama, etc.) EUR`,
  option___qui_paie_les_frais__5____: `Opção: Quem paga as taxas (5%)?`,
  standard__recommand__: `Padrão (recomendado)`,
  pro___attractivit_: `Pró/Atratividade`,
  le_voyageur_paie_5__en_plus__vous_touchez_100__du_: `O viajante paga 5% a mais. Você recebe 100% do preço.`,
  vous_payez_les_5___le_prix_affich__au_voyageur_est: `Você paga os 5%. O preço exibido ao viajante é líquido.`,
  base_de_calcul: `Base de cálculo`,
  nuit_s_: `noite(s)`,
  autres_frais: `Outros custos`,
  montant_total_avant_commissions: `Montante total antes de comissões`,
  plateforme: `Plataforma`,
  frais_h_te: `Taxas de hospedagem`,
  frais_voyageur: `Taxas de viagem`,
  total_voyageur: `Viajante total`,
  net_h_te: `Hospedeiro de rede`,
  avantage_fiscal___pro: `Vantagens fiscais e profissionais`,
  consultez_votre_expert_comptable_: `Consulte seu contador.`,
  diff_rence_h_te__claire_et_vendeuse: `Diferença do anfitrião: claro e comercial`,
  frais_h_te___an: `Taxas de acolhimento / ano`,
  _conomie_compar_e___booking: `Economia em comparação com Reserva`,
  _conomie_vs_airbnb: `Economia vs Airbnb`,
  exemple_typique_sur_1_an__h_te_: `Exemplo típico ao longo de 1 ano (anfitrião)`,
  nuits_r_serv_es: `Noites reservadas`,
  s_jours___an: `Estadias / ano`,
  chiffre_d_affaires_annuel: `Volume de negócios anual`,
  frais_traveltrok: `Taxas DONKEY TRAVEL`,
  frais_booking__15__: `Taxas de reserva (15%)`,
  frais_airbnb__15_5__: `Taxas do Airbnb (15,5%)`,
  net_h_te_traveltrok: `Anfitrião da rede DONKEY TRAVEL`,
  comparatif_des_modes: `Comparação de modos`,
  ce_que_tu_actives_selon_ton_usage_traveltrok_: `O que você ativa de acordo com seu uso do TRAVELTROK.`,
  fonction: `Função`,
  pro: `Pró`,
  cr_er_ton_compte_et_ton_mode_d_usage: `Crie sua conta e seu modo de uso`,
  choisis_si_tu_d_marres_en_voyageur__h_te__ou_les_d: `Escolha se você começa como viajante, anfitrião ou ambos. Você pode mudar a qualquer momento.`,
  location_simple_c_t__voyageur: `Aluguer individual do lado do passageiro`,
  recherche__filtres__r_servation_rapide_et_co_t_tra: `Pesquisa, filtros, reserva rápida e custo transparente.`,
  gestion_h_te_simplifi_e: `Gestão simplificada do anfitrião`,
  publie_ton_logement__g_re_ton_calendrier_et_r_pond: `Publique o seu alojamento, gira o seu calendário e responda rapidamente aos pedidos.`,
  couverture_incluse_pour_le_voyageur_et_pour_l_h_te: `Cobertura incluída para o viajante e o anfitrião.`,
  support_op_rationnel: `Apoio operacional`,
  accompagnement_en_cas_de_litige__annulation_ou_bes: `Apoio em caso de litígio, cancelamento ou necessidade de mediação.`,
  faq_tarifs: `Perguntas frequentes sobre preços`,
  vraiment_0__de_commission_pour_l_h_te__: `Realmente 0% de comissão para o anfitrião?`,
  oui__l_h_te_re_oit_100__du_prix_qu_il_fixe__aucun_: `Sim. O anfitrião recebe 100% do preço definido. Sem taxas de serviço, sem taxas de processamento.`,
  combien_paie_le_voyageur__: `Quanto o viajante paga?`,
  le_voyageur_paie_une_commission_de_5__sur_le_monta: `O viajante paga uma comissão de 5% sobre o valor do aluguel. Isso cobre custos operacionais, seguros e suporte.`,
  puis_je__changer_mon_logement_gratuitement__: `Posso trocar meu alojamento gratuitamente?`,
  oui___si_vous__tes_h_te__vous_pouvez__changer_votr: `Sim ! Se for anfitrião, poderá trocar o seu alojamento com outros membros sem qualquer taxa (0€).`,
  pourquoi_ce_mod_le_est_il_moins_cher__: `Por que esse modelo é mais barato?`,
  en_ne_prenant_que_5__au_total__contre_15____20__ai: `Ao retirar apenas 5% do total (em comparação com 15% a 20% noutros locais), tornamos as viagens mais acessíveis e, ao mesmo tempo, pagamos melhor aos anfitriões.`,
  pr_t___activer_ton_mode_traveltrok__: `Pronto para ativar seu modo DONKEY TRAVEL?`,
  voyageur__h_te__ou_hybride__commence_avec_une_logi: `Viajante, anfitrião ou híbrido: começa com uma lógica clara e custos controlados.`,
  cr_er_mon_compte: `Criar minha conta`,
  explorer_les_logements: `Explorar alojamento`,
  donn_es_personnelles: `Dados pessoais`,
  politique_de_confidentialit_: `Política de Privacidade`,
  rejoignez_notre_communaut__et_r_servez_un_logement: `Junte-se à nossa comunidade e reserve acomodação em {{city}} com taxas fixas claras e seguro incluído.`,
  une_plateforme_d__changes_europ_enne_r_serv_e_aux_: `Uma plataforma de intercâmbio europeia reservada para anfitriões Airbnb`,
  club_priv__pour_h_tes_not_s_4_5____un_abonnement_u: `Clube privado para hóspedes com classificação 4,5+: uma assinatura exclusiva para intercâmbio em toda a Europa.`,
  r_serv__aux_h_tes_airbnb_avec_une_note_sup_rieure_: `Reservado para anfitriões do Airbnb com classificação maior ou igual a 4,5.`,
  r_duction_de_50__en_2026__25eur_an_au_lieu_de_50eu: `Redução de 50% em 2026: 25EUR/ano em vez de 50EUR/ano. Preço garantido vitaliciamente para as primeiras 1000 inscrições.`,
  basse_saison__pause__rencontres_entre_h_tes__conom: `Época baixa, pausas, reuniões entre hóspedes, poupanças nas férias: tudo pensado para hóspedes activos na Europa.`,
  voyagez_moins_cher__5__de_frais___h_bergez_sans_fr: `Viaje mais barato (taxas de 5%), hospede gratuitamente (0%). O modelo mais justo do mercado.`,
  fini_les_commissions_de_15__ou_plus__avec_traveltr: `Não há mais comissões de 15% ou mais. Com o DONKEY TRAVEL, os anfitriões não pagam taxas. Os viajantes pagam apenas 5% de taxa de serviço. Isso é justiça.`,
  hypoth_se_comparatif__booking_commission_h_te_15__: `Hipótese comparativa: Comissão de reserva do anfitrião de 15% (dependendo do país e do programa), modo somente anfitrião do Airbnb de 15,5% do lado do anfitrião e 0 do lado do viajante.`,
  les_frais_de_5__peuvent__tre_d_ductibles_de_vos_ch: `A taxa de 5% pode ser dedutível de suas despesas se você for uma empresa. O modelo 0% simplifica a contabilidade pessoal.`,
  avec_traveltrok__vous_pouvez_baisser_le_prix_de_vo: `Com o DONKEY TRAVEL, você pode baixar o preço dos seus aluguéis para alugar com mais frequência. Suas taxas de hospedagem permanecem fixas, portanto sua rede permanece forte.`,
  en_moyenne__c_est_environ___annualhostcase_average: `Em média, é cerca de {{savings}}EUR em economia anual em comparação com plataformas baseadas em comissões.`,
  hypoth_ses__100eur_la_nuit__30eur_de_m_nage__dur_e: `Pressupostos: 100EUR por noite, 30EUR de limpeza, duração média de 3 noites, taxa de reserva anual de 50%.`,
  traveltrok_collecte_uniquement_les_donn_es_n_cessa: `A DONKEY TRAVEL apenas recolhe os dados necessários ao funcionamento do serviço: conta, perfil, trocas e suporte.`,
  vos_donn_es_ne_sont_partag_es_qu_avec_les_services: `Seus dados são compartilhados apenas com serviços técnicos essenciais (autenticação, hospedagem, segurança) e nunca são revendidos.`,
  vous_pouvez_demander_la_mise___jour_ou_la_suppress: `Você pode solicitar a atualização ou exclusão de seus dados pessoais de sua conta ou entrando em contato com o suporte.`,
  "help.faq.q1.question": "Quanto custa a assinatura?",
  "help.faq.q1.answer":
    "50€/ano para o plano clássico. Há um desconto de lançamento a 25€/ano para 2026.",
  "help.faq.q2.question": "Posso trocar sem ter as mesmas datas?",
  "help.faq.q2.answer":
    "Absolutamente. Nosso sistema de troca flexível permite que o anfitrião 1 vá para a casa do anfitrião 2 em julho e o anfitrião 2 vá para a casa do anfitrião 1 em setembro, de forma assíncrona.",
  "help.faq.q3.question":
    "O site é realmente reservado para anfitriões com classificação 4.5 ou superior?",
  "help.faq.q3.answer":
    "Sim. O Donkey Travel é um clube fechado. No momento do registro, verificamos o link para o seu anúncio no Airbnb para garantir que sua classificação média seja de pelo menos 4.5/5 e que você tenha avaliações.",
  "help.faq.q4.question": "Como as trocas são organizadas?",
  "help.faq.q4.answer":
    "Não há sistema de pontos. Os membros decidem por si mesmos quantas noites desejam trocar com base no preço que indicam. O anúncio do Airbnb serve como referência para verificar se a proposta é justa e crível.",
  "help.faq.q5.question": "Há taxas adicionais (limpeza, serviço)?",
  "help.faq.q5.answer":
    "Não! O princípio do Donkey Travel é a troca 100% gratuita entre anfitriões. O anfitrião que recebe prepara a acomodação, e o hóspede a devolve em um estado de limpeza impecável (ou gerencia a limpeza com o anfitrião de acordo com seus acordos).",
  "help.faq.q6.question": "Posso vincular vários anúncios do Airbnb?",
  "help.faq.q6.answer":
    "Sim, isso está planejado em nossas próximas atualizações para permitir que você sincronize várias acomodações e ganhe ainda mais oportunidades de troca.",
  "help.faq.q7.question": "O que acontece se uma troca for cancelada?",
  "help.faq.q7.answer":
    "Em caso de cancelamento, convidamos você a se comunicar com seu anfitrião por meio de nossas mensagens internas para encontrar um novo acordo ou novas datas.",
  "help.faq.q8.question": "Como a confiança e a segurança são garantidas?",
  "help.faq.q8.answer":
    "Ao aceitar apenas anfitriões confirmados (classificação > 4.5), garantimos que todos os membros saibam o que significa 'hospedar'. Além disso, a identidade e os anúncios são verificados por nossa equipe.",
};
